module.exports = __webpack_public_path__ + "static/img/arrow-backward-outline.73a0d067.svg";